import { render, staticRenderFns } from "./CustExtOrder.vue?vue&type=template&id=2fb2d85c&scoped=true&"
import script from "./CustExtOrder.vue?vue&type=script&lang=js&"
export * from "./CustExtOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustExtOrder.vue?vue&type=style&index=0&id=2fb2d85c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2d85c",
  null
  
)

export default component.exports